<template>
    <div>
        <div class="text-xs-right">
            <v-btn class="white--text elevation-6" small round color="teal darken-2" to="/business-account/RequestHistory2">
                <span>My Deposit History</span>
            </v-btn>
        </div>
        <h2 class="elevation-4 primary white--text font-weight-bold subheading py-2 text-xs-center">Deposit TO CAMPAIGN</h2>

         Campaign Selection 
        <v-card class="elevation-4 mt-2" style="border-radius: 10px">
            <div class="pa-3" style="max-height: 300px; overflow: auto">
                <v-hover v-for="campaign in campaigns" :key="campaign.id">
                    <v-card 
                        :class="['campaign-card', { 'selected-campaign': selectedCampaign?.id === campaign.id }]"
                        @click="selectCampaign(campaign)"
                    >
                        <v-icon 
                            v-if="selectedCampaign?.id === campaign.id"
                            color="teal"
                            class="selected-check"
                        >mdi-check-circle</v-icon>
                        <v-card-text class="px-3 py-2" style="cursor: pointer">
                            <h2 class="teal--text">Campaign: {{ campaign.name }}</h2>
                            <div class="caption">
                                <p class="mb-1"><b>Created:</b> {{ formatDate(campaign.creation_date) }}</p>
                                <p v-if="campaign.target_amount" class="mb-1">
                                    <b>Target:</b> {{ campaign.target_amount }} FCFA
                                </p>
                                <p v-if="campaign.target_date" class="mb-0">
                                    <b>Deadline:</b> {{ formatDate(campaign.target_date) }}
                                </p>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-hover>
            </div>
        </v-card>

        <div class="elevation-4 white lighten-4 mt-3">
            <p class="dark--text subheading pa-2 ma-0">
                <b>Your Balance:</b> {{ userBalance }} FCFA
            </p>
            <v-divider></v-divider> 
        </div>

        <v-card color="elevation-4 white pa-1 pl-2">
            <p class="dark--text caption pt-2 ma-0 text-xs-center">Transfer funds to selected campaign</p>
            <v-layout row>
                <v-flex xs12 md10 offset-md1>
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-money-bill fa-2x mt-2"></i>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-text-field
                            class="pa-0 mt-2"
                            v-model="depositAmount"
                            label="Input amount (F CFA)"
                            :rules="[
                                v => !!v || 'Amount is required',
                                v => parseFloat(v) > 0 || 'Amount must be positive',
                                v => parseFloat(v) <= userBalance || `Insufficient balance (max: ${userBalance} F CFA)`
                            ]"
                            color="teal"
                            type="number"
                            min="0.01"
                            step="0.01"
                            />

                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
           
                <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                     <div class="text-xs-center">
                    <v-btn
                    class="white--text elevation-6"
                    small
                    round
                    color="teal darken-2"
                    @click="openDialog"
                    :disabled="!isFormValid"
                    v-bind="attrs"
                    v-on="on"
                    >
                    <span>Submit</span>
                    </v-btn>
                </div>
                </template>
                <span v-if="!isFormValid" class="red--text text--darken-2">
                    Please complete the form correctly before submitting.
                </span>
                
                </v-tooltip>

           
        </v-card>


        <v-dialog width="500px" v-model="Dialog">
            <v-card>
                <v-card-title class="headline primary darken-2 white--text" primary-title>Confirm Deposit</v-card-title>
                <v-card-text class="pa-4">
                    <p class="text-xs-center mb-0">
                        Please fill in your password for security reasons. For us to be sure you have the withdrawal rights for this account.
                    </p>
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-lock fa-2x mt-3"></i>
                        </v-flex>
                       <v-flex xs9 sm10>
                        <v-text-field
                            class="pa-0 mt-2"
                            id="securityKey"
                            v-model="password"
                            ref="securityInput"
                            label="Enter Password"
                            autocomplete="cc-autocomplete-off" 
                            :rules="[v => !!v || 'Your Password is required (at least 8 characters)']"
                            single-line
                            color="teal"
                            min="8"
                            :append-icon="e1 ? 'visibility_off' : 'visibility'"
                            @click:append="() => (e1 = !e1)"
                            :type="e1 ? 'text' : 'password'"
                            name="secureCode" 
                            counter
                            style="position: relative;"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-actions class="px-3">
                    <v-btn color="teal" flat @click="closeDialog">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn :loading="ConfirmDeposit" color="teal darken-2" class="white--text" @click="requestWithdrawal">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import 'animate.css'
import 'vuetify/dist/vuetify.min.css';
import { VTooltip } from 'v-tooltip'

export default {
    data() {
        return {
            Dialog: false,
            password: "",
            e1: true,
            depositAmount: "",
            campaigns: [],
            selectedCampaign: null,
            userBalance: 0,
            ConfirmDeposit: false,
        };
    },
    computed: {
        isFormValid() {
            return this.selectedCampaign && this.depositAmount > 0;
        }
    },
    async mounted() {
        await this.fetchCampaigns();
        await this.fetchUserBalance();
    },
    methods: {
        formatDate(dateString) {
            const options = { year: 'numeric', month: 'short', day: 'numeric' };
            return new Date(dateString).toLocaleDateString('en-US', options);
        },
        selectCampaign(campaign) {
            this.selectedCampaign = campaign;
        },
        async fetchCampaigns() {
            try {
                const response = await axios.get('/api/v1/home/get/user/campaigns/active/');
                this.campaigns = response.data;
            } catch (error) {
                this.showError('Failed to load campaigns');
            }
        },
        async fetchUserBalance() {
            try {
                const response = await axios.get('/api/v1/home/user/balance/');
                this.userBalance = response.data.balance;
            } catch (error) {
                this.handleError('Failed to load balance');
            }
        },
    
async requestWithdrawal() {
    if (!this.password || !this.selectedCampaign) return;

    try {
        // Vérifiez d'abord le mot de passe
        const passwordCheckResponse = await axios.post('/api/v1/home/check/password/', {
            password: this.password
        });

        if (passwordCheckResponse.status !== 200) {
            this.showError("🔒 incorrect password");
            return;
        }

        // Vérifiez si le montant est valide
        if (this.depositAmount <= 0 || this.depositAmount > this.userBalance) {
            this.showError("❌ The amount must be between 0.01 and " + this.userBalance);
            return;
        }

        // Générer le payment_ref
        const paymentRefResponse = await axios.get(`/api/v1/home/generate/payment_ref/${this.selectedCampaign.id}/`);
        const payment_ref = paymentRefResponse.data;

        const payload = {
            amount: Number(this.depositAmount),
            campaign_id: this.selectedCampaign.id,
            password: this.password,
            payment_ref: payment_ref 
        };

        this.ConfirmDeposit = true;
        const response = await axios.post('/api/v1/home/campaign/deposit/', payload);
        
        // Mise à jour de l'état local
        this.userBalance = response.data.new_balance;
        this.updateCampaignBalance(response.data.campaign_balance);
        
        // Notification de succès stylée
        this.$store.commit('setSnackBarMessage', "🎉 Succès ! Deposit made. New balance. : " + this.userBalance + " FCFA");
        this.$store.commit('setSnackBarColor', "teal darken-2");
        this.$store.commit('activateSnackBar', true);

        this.closeDialog();
        this.$router.push('/business-account/transactions/all');
        this.closeDialog();
        this.ConfirmDeposit = false;
    } catch (error) {
        let errorMessage = "🌐 Erreur réseau - Please check your connection";
        let errorColor = "red darken-4";
        
        if (error.response) {
            switch (error.response.status) {
                case 400:
                    errorMessage = "⚠️ " + (error.response.data.error || "Invalid request");
                    break;
                case 401:
                    errorMessage = "🔒 Authentication failed - Please check your password";
                    break;
                case 404:
                    errorMessage = "🚫 Campaign not found";
                    break;
                case 500:
                    errorMessage = "🚨 Server error - Please try again later";
                    break;
            }
        }

        this.$store.commit('setSnackBarMessage', errorMessage);
        this.$store.commit('setSnackBarColor', errorColor);
        this.$store.commit('activateSnackBar', true);
        this.closeDialog();
        this.ConfirmDeposit = false;
    }
},
    

        showError(message) {
            this.$store.commit('setSnackBarMessage', "❌ " + message);
            this.$store.commit('setSnackBarColor', "red darken-4");
            this.$store.commit('activateSnackBar', true);
        },
        updateCampaignBalance(newBalance) {
            const campaignIndex = this.campaigns.findIndex(c => c.id === this.selectedCampaign.id);
            if (campaignIndex > -1) {
                this.$set(this.campaigns, campaignIndex, {
                    ...this.campaigns[campaignIndex],
                    saved_amount: newBalance
                });
            }
        },
        handleError(message) {
            this.$store.commit('setSnackBarMessage', message);
            this.$store.commit('setSnackBarColor', 'error');
            this.closeDialog();
        },
        openDialog() { this.Dialog = true; },
        closeDialog() { 
            this.Dialog = false;
            this.password = "";
        }
    }
};
</script>


<style>
.selected-campaign {
    border: 2px solid #009688 !important;
    background-color: #e0f2f1 !important;
    transition: all 0.3s ease;
}

.campaign-card {
    position: relative;
    margin-bottom: 12px;
    cursor: pointer;
}

.selected-check {
    position: absolute;
    top: 8px;
    right: 8px;
    font-size: 24px;
}


.masked-password input {
  -webkit-text-security: disc; /* Masque les caractères pour WebKit */
  text-security: disc; /* Standard futur */
}


/* Solution de repli pour Firefox */
@-moz-document url-prefix() {
  .masked-password input[type="text"] {
    font-family: monospace !important;
    font-size: 0.8em !important;
    letter-spacing: 0.2em;
  }
}
</style> 